import type { AnimationConfig } from './types';

export class AnimationObserver {
  private observer: IntersectionObserver;
  public animatedElements = new WeakSet<Element>();

  constructor(
    private config: AnimationConfig,
    private onIntersect: (element: Element) => void
  ) {
    this.observer = this.createObserver();
  }

  private createObserver(): IntersectionObserver {
    return new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.animatedElements.has(entry.target)) {
          this.onIntersect(entry.target);
          this.animatedElements.add(entry.target);
        }
      });
    }, {
      root: this.config.root,
      rootMargin: this.config.rootMargin,
      threshold: this.config.threshold
    });
  }

  observe(element: Element): void {
    this.observer.observe(element);
  }

  unobserve(element: Element): void {
    this.observer.unobserve(element);
  }

  disconnect(): void {
    this.observer.disconnect();
  }
}